"use client";

import React from "react";
import { IlluminatedImageHandle, IlluminationMode } from "./Definitions";
import { IlluminatedImageBase, IlluminatedImageBaseProps } from "./IlluminatedImageBase";

interface IlluminatedImageProps extends IlluminatedImageBaseProps
{
    mode: IlluminationMode;
    trigger?: number;
}

export const IlluminatedImage = ({ mode, trigger, ...props }: IlluminatedImageProps): React.ReactComponentElement<"object", IlluminatedImageProps> =>  // React.FunctionComponentElement<ImageProps> =>
{
    const illuminatedImageRef = React.useRef<IlluminatedImageHandle>(null);

    React.useEffect(() =>
    {
        illuminatedImageRef.current?.execute(mode.diagram);

    }, [mode.diagram, trigger]);

    return <IlluminatedImageBase {...props} ref={illuminatedImageRef} />;
}